// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bTSZ","controls":"styles_controls__1g6G5","charLimit":"styles_charLimit__23QjY","input":"styles_input__15Dx1","send":"styles_send__Zf3dS"};